import { isNull } from '@angular/compiler/src/output/output_ast';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CONFIG } from '../../../core/config';
import { LanguageService } from '../../../core/language/language.service';
import { DropdownItem } from '../../../core/models/dropdown-item';
import { ParticipantDetails } from '../../../core/models/surveys/participant-details';
import { Survey } from '../../../core/models/surveys/survey';
import { SecurityService } from '../../../core/services/security.service';
import { SpinnerService } from '../../../core/spinner/spinner.service';
import { ToastService } from '../../../core/toast/toast.service';
import { SharedService } from '../../../shared/shared.service';
import { SurveysService } from '../../surveys.service';

@Component({
    selector: 'app-participant-details',
    templateUrl: './participant-details.component.html',
    styleUrls: ['./participant-details.component.css']
})
export class ParticipantDetailsComponent implements OnInit, OnDestroy {
    public survey: Survey;
    private languageID: number;
    public pathname: string;
    public participantDetails: ParticipantDetails;
    public sex: DropdownItem[];
    public territory: DropdownItem[];
    public ageStructure: DropdownItem[];
    public sensitiveCategory: DropdownItem[];
    public unemploymentPeriod: DropdownItem[];

    public userProfileId: number;

    public organizations: DropdownItem[] = [];

    constructor(private _surveysService: SurveysService,
        private _sharedService: SharedService,
        private _securityService: SecurityService,
        private _languageService: LanguageService,
        private _route: ActivatedRoute, private _router: Router,
        private _toastService: ToastService,
        private _spinnerService: SpinnerService) {
        this.survey = new Survey();
        this.participantDetails = new ParticipantDetails();
        this.languageID = this._languageService.selectedLanguageId;
    }
    ngOnDestroy(): void {
        //this._surveysService.removeSurveyParticipantIDFromLocalStorage();
    }

    ngOnInit() {
        this.pathname = location.pathname;
        this.pathname = this.pathname.replace('/fill-survey', '');
        this.pathname = this.pathname.substring(0, this.pathname.indexOf("participant-details") + "participant-details".length);

        this._securityService.currentUser.subscribe(result => {
            this.userProfileId = result ? result.profileId : 0
        });

        this._route.params.subscribe(params => {
            let id = params['id'];
            this.participantDetails.surveyParticipantID = parseInt(this._surveysService.getSurveyParticipantID());
           
            if (id != null) {                
                this.intiParticipantDetails();
                this._surveysService.getSurveyByID(id, this.participantDetails.surveyParticipantID, this.languageID).subscribe(result => {
                    this.survey = result;
                    if (this.survey.sexId > 0) {                       
                        this.redirectToQuestions();
                    }
                });
                this.fillDropdownLists();

            } else {
                //redirect
            }
        });
    }
    intiParticipantDetails() {
        this.participantDetails.ageStructureID = 0;
        this.participantDetails.sexID = 0;
        this.participantDetails.sensitiveCategoryID = 0;
        this.participantDetails.territoryID = 0;
        this.participantDetails.unemploymentPeriodID = 0;
    }

    fillDropdownLists() {
        this._surveysService.getAllAgeStructuresForDropdown(0, true, this.languageID).subscribe(result => {
            this.ageStructure = result;
            //console.log(result);
        });

        this._surveysService.getAllSexesForDropdown(0, true, this.languageID).subscribe(result => {
            this.sex = result;
        });

        this._surveysService.getAllTerritoriesForDropdown(0, true, this.languageID).subscribe(result => {
            this.territory = result;
        });

        this._surveysService.getAllMasterSurveySensitiveCategoriesForDropdown(0, true, this.languageID).subscribe(result => {
            this.sensitiveCategory = result;
        });

        this._surveysService.getAllUnenploymentPeriodForDropdown(0, true, this.languageID).subscribe(result => {
            this.unemploymentPeriod = result;
        });
    }
    validate(): boolean {
         if (this.participantDetails.ageStructureID == 0 || this.participantDetails.territoryID == 0 || this.participantDetails.sexID == 0 ||
            (this.participantDetails.sensitiveCategoryID == 0) || (this.participantDetails.sensitiveCategoryID == 1 && this.participantDetails.unemploymentPeriodID == 0)) {
            return false;
        } else
            return true;
    }
    save() {
        if(this.validate() == false)
        {
            this._toastService.activate(this._languageService.translate("podaci_neispravni"), "alert-dangerToast");
            return;
        }

        if (this.participantDetails.sensitiveCategoryID != 1) {
            this.participantDetails.unemploymentPeriodID = 0;
        }

        this._surveysService.saveParticipantDetails(this.participantDetails).subscribe(result => {
            if (result) {
                this._surveysService.saveSurveyParticipantID(this.participantDetails.surveyParticipantID.toString());
                this.redirectToQuestions();
            }
        });
    }
    redirectToQuestions() {       
        this._router.navigate(['/survey/fill-survey/survey-details', this.survey.surveyUniqueIdentifier, 1, false]);
    }

    redirectToList() {
        let link = "";
        if (this.userProfileId == CONFIG.profileEnum.Anketar) {
            link = "/survey/all-surveys";
            this._router.navigate([link]);        
        } else  {
            link = "/survey/public-surveys";
            this._router.navigate([link]); 
        }
    }

}
